<template>
  <section class="legal-content position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-5 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-6 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-7 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-8 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>

    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="legal-content-wrapper">
            <div 
              v-for="(section, index) in content.sections" 
              :key="index"
              class="legal-section"
            >
              <h3>{{ section.title }}</h3>
              <div v-for="(paragraph, pIndex) in section.paragraphs" :key="pIndex">
                <p v-if="paragraph.type === 'text'" v-html="paragraph.content"></p>
                <ul v-else-if="paragraph.type === 'unordered'">
                  <li v-for="(item, itemIndex) in paragraph.items" :key="itemIndex" v-html="item"></li>
                </ul>
                <ol v-else-if="paragraph.type === 'ordered'">
                  <li v-for="(item, itemIndex) in paragraph.items" :key="itemIndex" v-html="item"></li>
                </ol>
              </div>
              <div v-if="section.contactInfo" class="contact-info">
                <p v-for="(contact, contactIndex) in section.contactInfo" :key="contactIndex">
                  <strong>{{ contact.label }}:</strong> {{ contact.value }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PolicyContentComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sections: [
          {
            title: "Section Title",
            paragraphs: [
              {
                type: "text",
                content: "Section content goes here."
              }
            ]
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Import Flaticon */
@import "@/assets/scss/Flaticon.scss";

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Legal Content Section */
.legal-content {
  background: #00061a;
  position: relative;
  overflow: hidden;
}

.legal-content-wrapper {
  position: relative;
  z-index: 2;
  max-width: 900px;
  margin: 0 auto;
}

.legal-section {
  margin-bottom: 50px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  border: 1px solid rgba(246, 236, 79, 0.1);
  transition: all 0.3s ease;
}

.legal-section:hover {
  border-color: #f6ec4f;
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-5px);
}

.legal-section h3 {
  font-size: 28px;
  font-weight: 700;
  color: #f6ec4f;
  margin-bottom: 25px;
  font-family: "Archivo", sans-serif;
  border-bottom: 2px solid rgba(246, 236, 79, 0.3);
  padding-bottom: 15px;
}

.legal-section p {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif;
}

.legal-section ul,
.legal-section ol {
  margin: 20px 0;
  padding-left: 30px;
}

.legal-section li {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
  margin-bottom: 10px;
  font-family: "Open Sans", sans-serif;
}

.legal-section ul li {
  list-style-type: disc;
}

.legal-section ol li {
  list-style-type: decimal;
}

.contact-info {
  background: rgba(246, 236, 79, 0.1);
  padding: 20px;
  border-radius: 10px;
  margin-top: 20px;
  border-left: 4px solid #f6ec4f;
}

.contact-info p {
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  font-family: "Open Sans", sans-serif;
}

.contact-info strong {
  color: #f6ec4f;
  font-weight: 600;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .see__pad {
    padding: 80px 0;
  }
  
  .legal-section {
    padding: 30px;
    margin-bottom: 40px;
  }
}

@media only screen and (max-width: 767px) {
  .see__pad {
    padding: 60px 0;
  }

  .legal-section {
    padding: 25px;
    margin-bottom: 30px;
  }

  .legal-section h3 {
    font-size: 24px;
  }

  .pattern-5,
  .pattern-6,
  .pattern-7,
  .pattern-8 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .see__pad {
    padding: 40px 0;
  }

  .legal-section {
    padding: 20px;
    margin-bottom: 25px;
  }

  .legal-section h3 {
    font-size: 20px;
  }

  .legal-section p,
  .legal-section li {
    font-size: 14px;
    line-height: 22px;
  }

  .contact-info {
    padding: 15px;
  }
}
</style>
